<p class="text-justify">{{ "dummy-text" | translate}}</p>
